import styled from '@emotion/styled';

import Button from '../Button';

export const UploadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: 100%;
	height: ${(props) => (props.height ? props.height : '20rem')};
	border: 1.5px dashed var(--black-10);
	background-color: var(--white);
	border-radius: var(--small-border-radius);

	> div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.iconPosition {
		margin-bottom: 2rem;
	}

	:hover {
		border: 1.5px dashed var(--blue);
		background-color: var(--modal-bg-2);
		cursor: pointer;
	}

	&.focus {
		border: 1.5px dashed var(--blue);
		background-color: var(--blue-10);
	}

	&.error {
		border: 1px dashed var(--red);
		background-color: var(--red-10);
		pointer-events: unset;
		cursor: pointer;
	}

	&.disabled {
		pointer-events: none;
		cursor: not-allowed;
		background-color: var(--input-disabled-bg-color);
		border-color: var(--border-color);
		border: unset;

		.icon,
		.typography {
			color: var(--content-4);
		}
	}

	body[dir='rtl'] & {
		height: 25rem;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const BrowseButton = styled(Button)`
	text-decoration: underline !important;
	background-color: transparent !important;
	padding: 0 0.5rem !important;
	color: var(--blue-40) !important;
`;

export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: var(--input-bg-color);
	border: 1px solid var(--border-color);
	padding: 0 var(--inputPadding);
	height: 4.4rem;

	width: 100%;
	justify-content: space-between;
	div {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 4rem;
	}

	${({ errorMessage }) => errorMessage && `border: 1px solid var(--red);`}
	${({ errorMessage }) => errorMessage && `background-color: var(--red-10);`}
`;

export const StatusContainer = styled.div`
	text-align: center;
	align-items: center;
	place-content: center;
	display: flex;
	width: 9rem;
	height: 2.8rem;
	border-radius: 400px;
`;

export const ImageContainer = styled.div`
	max-width: 100%;
	height: ${(props) => (props.height ? props.height : '20rem')};
`;

export const Miniscreen = styled.div`
	position: relative;
	width: fit-content;
	height: ${(props) => (props.height ? props.height : '20rem')};

	:hover {
		> div {
			display: flex;
		}
	}

	> img {
		border-radius: 4px;
		object-fit: contain;
		object-position: left;
	}
`;

export const DarkContainer = styled.div`
	width: 100%;
	height: 100%;
	z-index: 1;
	display: none;
	position: absolute;
	top: 0;
	border-radius: 4px;
	justify-content: center;
	align-items: center;

	background-color: rgba(0, 0, 0, 0.5);
	animation: fadeIn 0.4s ease;

	@keyframes fadeIn {
		from {
			background-color: rgba(0, 0, 0, 0);
		}
		to {
			background-color: rgba(0, 0, 0, 0.5);
		}
	}
`;

export const IconContainer = styled.div`
	cursor: pointer;

	padding: var(--padding-2);
	border: 1px solid var(--border-color);
	border-radius: 4px;
	transition: transform 0.1s ease;

	:hover {
		transform: scale(1.1);
	}
`;
